import axios from "axios";
import { kycSuccessRemitter, kycSuccessStudent } from "../../Reducer/Kyc";
import HoldOn from "react-hold-on";
import apiUrl from "../../ApiUrl";


//kyc action for remitter
export const kycActionForRemitter = (data) => async (dispatch) => {
    let options = {
        theme: "sk-cube-grid",
        message: "Fetching user details...",
    };
    try {
        HoldOn.open(options);
        const response = await axios.post(`${apiUrl}kyc/remitter`, data);
        if(response.data){
            console.log("kyc data", response.data);
            dispatch(kycSuccessRemitter(response.data?.kyc_id?.kyc_id));
            return response.data;
        }
    } catch (error) {
        console.log(error);
        HoldOn.close();
        throw error;
    }
}
export const kycActionForStudent = (data) => async (dispatch) => {
    let options = {
        theme: "sk-cube-grid",
        message: "Fetching user details...",
    };
    try {
        HoldOn.open(options);
        const response = await axios.post(`${apiUrl}kyc/user`, data);
        if(response.data){
            console.log("kyc data", response.data);
            dispatch(kycSuccessStudent(response.data?.kyc_id?.kyc_id));
            return response.data;
        }
    } catch (error) {
        console.log(error);
        HoldOn.close();
        throw error;
    }
}
